/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import ReactModal from 'react-modal';
import queryString from 'query-string';
import { keyframes } from '@emotion/react';

/* Profile Actions Bar */
import Button from '../../../atoms/buttons/Button';
import BlankSlate from '../../blocks/BlankSlate';
import { css } from 'glamor';

/* OfferComponent */
import OfferCreate from '../Offers/OfferCreate';

/* sidebar components */
import InterestedIn from './InterestedIn';

import BlockOrReport from '../../../atoms/BlockOrReport';
import ExperimentInjector from '../../../modules/ExperimentInjector';
import { displayUserLocation, renderAvatar, getOfferType } from '../../../common';
import { scrollToTop, isDarkMode, removeForbiddenCharacters } from '../../../utils/helpers';

/* right side bar components */
import PersonalInfo from './PersonalInfo';
// import Container from '../../blocks/Container';
import Panel from '../../../atoms/panels/Panel';
import Photos from './Photos';
import AboutMe from './AboutMe';
import FirstDate from './FirstDate';

import PhotoLightbox from '../Photos/PhotoLightbox';
import LoadingMsg from '../../common/LoadingMsg';
import OfferPanelV2 from '../../../atoms/profile/OfferPanelV2';

import { getBackgroundTheme, spacing, getTextColor } from '../../../style';
import { CloseOutlined } from '@material-ui/icons';
import { SvgIcon } from '@material-ui/core';
import {
  sendClose,
  displayOfferModal,
  counterModal,
  counterModalClose,
  profileMakeOffer,
} from '../../../actions/profileTrackAction';
import { vysionTrack } from '../../../utils/vysion/vysionService';
import { s3BucketContentDir } from '../../../config/Master';
import Text from '../../common/Text';
import _sortBy from 'lodash/sortBy';
import _isEmpty from 'lodash/isEmpty';
import useMixPanel from '../../../hooks/useMixPanel';
import useModal from '../../../hooks/useModal';
import HeaderOut from '../../../atoms/HeaderOut';
import ButtonSet from '../../blocks/ButtonSet';
import { useLocation, useNavigate } from 'react-router-dom';
import TrackLoadingToMixpanel from '../../common/TrackLoadingToMixPanel';
import LoadingBackdrop from '../../../atoms/loader/LoadingBackdrop';
import OpeningOffer from './OpeningOffer';
import Optional from '../../../atoms/Optional';
import useNotificationBanner from '../../../hooks/useNotificationBanner';
import FavoritedProfileNotificationBanner from '../../../atoms/profile/FavoritedProfileNotificationBanner';
import { useProfile } from '../../../contexts/ProfileContext';
import OtherProfileCover from '../../../modules/OtherProfileCover';
import MyProfileCover from '../../../modules/MyProfileCover';
import ArrowBackIcon from '../../../atoms/icons/ArrowBackIcon';
import { ProfileMaker } from '../../../models/Profile';
import { mixpanelTrackEvent } from '../../../utils/mixpanel/common';
import { EVENT_NAMES } from '../../../constants/mixpanel';
import { toggleBlockInStore, toggleBlockProfile } from '../../../actions/profileActions';
import { favToggle, storeProfileFavChange } from '../../../actions/favActions';
import { clearNotificationMessage } from '../../../actions/notificationActions';
import { unlockOutsideMessage } from '../../../actions/mailActions';
import { createNewOffer as createNewOfferProps, counterOffer, sendSuggestion } from '../../../actions/offerActions';
import { ProfileObject } from '../../../models/types/Profile';
import { RootState } from '../../../store';
import useMediaBreakpoints from '../../../hooks/useMediaBreakpoints';
import breakpoints from '../../../theme/material/breakpoints';
import useMandatoryWall from '../../../hooks/useMandatoryWall';
import MyVerifications from './MyVerifications';
import { useCommonModal } from 'contexts/ModalContext';

const ternaryFunc = (evaluator, result1, result2) => {
  return evaluator ? result1 : result2;
};

const StyledContainer = styled('div')<{ isLightboxOpen: boolean }>(({ isLightboxOpen }) => ({
  display: 'flex',
  maxWidth: 1150,
  padding: '0 0 140px 0',
  margin: '0 auto',
  ...spacing.MARGIN_TOP_LG,
  [breakpoints.down(1185)]: {
    paddingLeft: 15,
    paddingRight: 15,
  },

  [breakpoints.down('sm')]: {
    display: 'block',
    position: ternaryFunc(isLightboxOpen, 'unset', 'absolute'),
    top: ternaryFunc(isLightboxOpen, '-60px', 0),
    left: 0,
    zIndex: 900,
    width: '100%',
    backgroundColor: getBackgroundTheme().block,
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: 0,
  },
  [breakpoints.down(768)]: {
    padding: '0 0 115px 0',
  },
  [breakpoints.down(479)]: {
    marginTop: ternaryFunc(isLightboxOpen, -16, 0),
  },
}));

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const MainPanel = styled(Panel)({
  marginBottom: 15,
  border: 0,
  [breakpoints.down(768.05)]: {
    boxShadow: 'none',
    borderRadius: 0,
    marginBottom: 0,
    paddingBottom: 0,
  },
  [breakpoints.down(834)]: {
    marginBottom: 15,
  },
  [breakpoints.down(621)]: {
    padding: 0,
    border: 0,
  },
});

const WrappedWithMobile = styled('div')({
  display: 'none',
  [breakpoints.down(834)]: {
    display: 'block',
  },
});

const WrappedWithDesktop = styled('div')({
  display: 'block',
  [breakpoints.down(834)]: {
    display: 'none',
  },
});

const ProfileHeading = styled('div')({
  borderRadius: 0,
  borderBottomWidth: 1,
  marginBottom: 0,

  [breakpoints.down('sm')]: {
    marginBottom: 0,
  },

  [breakpoints.down(639)]: {
    padding: 0,
    border: 0,
  },
});

const ProfileGalleryWrapper = styled('div')({});

const LeftContent = styled('div')<{ isLightboxOpen: boolean }>(
  {
    flex: 1,
  },
  ({ isLightboxOpen }) => ({
    [breakpoints.down(479)]: {
      display: 'block',
      position: !isLightboxOpen ? 'unset' : 'absolute',
      top: !isLightboxOpen ? '-60px' : 0,
      left: 0,
      zIndex: 1000,
      width: '100%',
      backgroundColor: getBackgroundTheme().block,
    },
  })
);

const LeftContentMainPanel = styled('div')(({ isOtherProfile }: { isOtherProfile: boolean }) => ({
  [breakpoints.down('sm')]: {
    backgroundColor: isOtherProfile ? getBackgroundTheme().block2 : getBackgroundTheme().block3,
  },
}));

const LeftContentWrapper = styled('div')(() => ({
  [breakpoints.down('sm')]: {
    margin: 0,
  },
}));

const RightContent = styled('div')(() => ({
  marginLeft: 15,
  flexBasis: 356,

  [breakpoints.down('sm')]: {
    marginTop: 16,
    marginLeft: 0,
    marginRight: 0,
  },
}));

const OverlayStyles = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 10000,
  backgroundColor: 'rgba(0,0,0,0.65)',
  overflow: 'auto',

  [breakpoints.down(639)]: {
    backgroundColor: getBackgroundTheme().block,
  },
};

const animateSlideUp = keyframes`
  from {
    top: 24px;
  }
  80% {
    top: 24px;
  }
  to {
    top: 0px;
  }
`;

const ModalStyles = {
  backgroundColor: getBackgroundTheme().block,
  ...getTextColor().DARKER,
  position: 'relative',
  boxSizing: 'border-box',
  outline: 'none',
  maxHeight: '80vh',
  overflow: 'auto',
  ':focus': {
    outline: 'none',
  },

  [breakpoints.down(639)]: {
    height: '100%',
  },

  [breakpoints.up(640)]: {
    padding: 22,
    borderRadius: 10,
    position: 'relative',
    top: 80,
    maxWidth: 540,
    margin: '32px auto',
  },
};

const CloseBtn = styled('button')({
  appearance: 'none',
  border: 'none',
  background: 'none',
  width: '48px',
  height: '48px',
  position: 'absolute',
  top: 0,
  right: 0,
});

const CloseProfileContainer = styled('div')<{ hasStatus: boolean }>(
  {
    display: 'none !important',

    [breakpoints.down(834)]: {
      display: 'block !important',
      position: 'fixed',
      top: 10,
      left: 10,
      zIndex: 1000,
      padding: '16px',
      svg: {
        width: 40,
        height: 40,
      },
    },

    [breakpoints.down(479)]: {
      top: -1,
      left: 0,
      svg: {
        width: 28,
        height: 28,
      },
    },
  },
  ({ hasStatus }) => ({
    [breakpoints.down(479)]: {
      top: hasStatus ? 24 : -1,
      left: 0,
      animation: hasStatus ? `${animateSlideUp} 3.5s ease-in-out forwards` : 'none',
    },
  })
);

const BlockedContainer = styled('div')({
  background: '#F8E9EA',
  border: '2px solid #E21D4A',
  borderRadius: 4,
  padding: '40px 28px',
  textAlign: 'center',
});

const StyledText = styled(Text)(() => ({
  ...getTextColor().RED,
  fontWeight: 700,
  fontSize: 16,
}));

const closeButton = {
  fontSize: 32,
  color: '#0d5c93',
};

const CloseProfileHandler = styled('div')({
  float: 'left',
  cursor: 'pointer',
});

const getVideoSrc = media => {
  if (media.type === 'video') {
    return media.urls.media;
  }

  return null;
};

const getMediaThumbnail = gallery => {
  if (gallery.type === 'photo') {
    return gallery.urls.profile;
  }

  return gallery.urls.thumbnail ?? `${s3BucketContentDir}thumbs/private_eye.png`;
};

const getPropsValue = (value, properties) => {
  switch (properties.length) {
    case 1:
      return value[properties[0]];
    case 2:
      return value[properties[0]][properties[1]];
    case 3:
      return value[properties[0]][properties[1]][properties[2]];
    default:
      return;
  }
};

const getMyProfileData = (myprofile, props) => {
  const properties = props.split('.');

  return myprofile && myprofile.profile && getPropsValue(myprofile.profile, properties);
};

const getMyOfferData = (myOffer, props) => {
  const properties = props.split('.');

  return myOffer && getPropsValue(myOffer, properties);
};

const verifyURLParams = (queryStringParsed, props) => {
  return Boolean(queryStringParsed[props]) || false;
};

const getPersonalInfo = profileData => {
  const {
    hash_id,
    account_type,
    gender,
    body_types,
    height,
    children,
    smoking,
    drinking,
    education,
    occupation,
    income,
    net_worth,
    looking_female,
    looking_male,
  } = profileData;

  return {
    hash_id,
    account_type,
    gender,
    body_types,
    height,
    children,
    smoking,
    drinking,
    education,
    occupation,
    income,
    net_worth,
    looking_female,
    looking_male,
  };
};

const getInterestedIn = profileData => {
  const { dating_just_dating, dating_friendship, dating_marriage, dating_married, dating_adult, dating_mentorship } =
    profileData;

  return {
    dating_just_dating,
    dating_friendship,
    dating_marriage,
    dating_married,
    dating_adult,
    dating_mentorship,
  };
};

const isAttractive = acctProfile => acctProfile && acctProfile.account_type === 'Attractive';
const getAcctProfile = account => account && account.profile && account.profile.data;
const verifyIsOtherProfile = (acctProfile, myprofile) => acctProfile && myprofile.hash_id !== acctProfile.hash_id;
const verifyIsMyProfile = (acctProfile, myprofile) => acctProfile && myprofile.hash_id === acctProfile.hash_id;

const generatePhotoList = (account, isSlider = false) => {
  const photoList = [];
  const privatePhotoList = [];

  !_isEmpty(account) &&
    account.photo &&
    account.photo.data.map(photo => {
      // return if photo has missing or incomplete data
      if (!photo.hash_id) return;

      if (photo.id === null) {
        return privatePhotoList.push({
          order: parseInt(removeForbiddenCharacters(photo?.created_dt?.date)),
          src: `${s3BucketContentDir}resized/private_eye.png`,
          thumbnail: `${s3BucketContentDir}thumbs/private_eye.png`,
          private: true,
          is_avatar: false,
          privateReal: photo?.private,
          type: photo.type,
          rank: 2,
          meta: {
            mediaUrl: getVideoSrc(photo),
            status: photo.status,
          },
        });
      }

      return photoList.push({
        order: parseInt(removeForbiddenCharacters(photo?.created_dt?.date)),
        src: isSlider ? photo.urls : getMediaSrc(photo),
        thumbnail:
          photo?.private && photo.type === 'photo'
            ? `${s3BucketContentDir}thumbs/private_eye.png`
            : getMediaThumbnail(photo),
        private: false,
        is_avatar: photo.is_avatar,
        privateReal: photo?.private,
        type: photo.type,
        rank: photo.is_avatar ? 0 : photo?.private ? 2 : 1,
        meta: {
          mediaUrl: getVideoSrc(photo),
          status: photo.status,
        },
      });
    });

  //If user has any amount of private photos, adding only one private picture object to array
  if (privatePhotoList.length > 0) {
    privatePhotoList[0].total = privatePhotoList.length;
    photoList.push(privatePhotoList[0]);
  }

  return [_sortBy(photoList, ['rank', 'order']), _sortBy(privatePhotoList, ['rank', 'order'])];
};

const getMediaSrc = media => {
  if (media.type === 'photo') {
    return renderAvatar(media.urls);
  }

  return media.urls.thumbnail ?? `${s3BucketContentDir}thumbs/private_eye.png`;
};

const Profile: React.FC = () => {
  const { isMobile } = useMediaBreakpoints();
  const dispatch = useDispatch();
  const { prevPage } = useSelector((state: RootState) => state.common);
  const { evidently } = useSelector((state: RootState) => state.settings);
  const myprofile = useSelector((state: RootState) => state.profile);
  const account = useSelector((state: RootState) => state.extprofile);
  const { photo: photos } = useSelector((state: RootState) => state.profile);
  const onboarded =
    Boolean(myprofile.profile && myprofile.profile.data.city) &&
    myprofile.profile_complete &&
    Boolean(myprofile.photo && myprofile.photo.data.length > 0) &&
    Boolean(
      myprofile.photo &&
        myprofile.photo.data[0] &&
        myprofile.photo.data[0].status === 'approved' &&
        myprofile.photo.data[0].type === 'photo'
    );

  const location = useLocation();
  const navigate = useNavigate();
  const { gallerySwiper } = useProfile();
  const queryStringParsed = queryString.parse(location.search);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState<number | null>(null);
  const [allowZoom] = useState(true);
  const [justSuggested, setJustSuggested] = useState(false);
  const [isCounter, setIsCounter] = useState(verifyURLParams(queryStringParsed, 'isCounter'));
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(verifyURLParams(queryStringParsed, 'fromOfferList'));
  const [, setSliderPosition] = useState(1);
  const [, setIsLightbox] = useState(false);
  const [, setHasErrors] = useState(false);
  const [ignored] = useState(false);
  const acctProfile = getAcctProfile(account);
  const isOtherProfile = verifyIsOtherProfile(acctProfile, myprofile);
  const isEditable = verifyIsMyProfile(acctProfile, myprofile);
  // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
  const myOffer = _find(['offer', 'data'], account) || null;
  const [showOfferTutorial, setShowOfferTutorial] = useState(false);
  const [isGenerous, setIsGenerous] = useState(false);

  const { trackPackagesPageVisited } = useMixPanel();
  const { basicModal, resetModal } = useModal();
  const { setShowTooManyPendingOfferModal } = useCommonModal();

  const { showMandatoryWall } = useMandatoryWall();

  const memoisedAccountAvatar = useMemo(() => {
    if (!acctProfile?.avatar?.data?.urls) return null;

    return renderAvatar(acctProfile?.avatar?.data?.urls);
  }, [acctProfile?.avatar?.data?.urls]);

  const memoisedAccountThumbAvatar = useMemo(() => {
    if (!acctProfile?.avatar?.data?.urls) return null;

    return renderAvatar(acctProfile?.avatar?.data?.urls, true);
  }, [acctProfile?.avatar?.data?.urls]);

  const [photoList, privatePhotoList] = generatePhotoList(isOtherProfile ? account : myprofile);

  useEffect(() => {
    setIsGenerous(
      myprofile && myprofile.profile && Boolean(getMyProfileData(myprofile, 'data.account_type') === 'Generous')
    );
    const queryStringParsed = queryString.parse(location.search);

    if (queryStringParsed.successfulMigration === 'true') showSuccessMigrateModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShowOfferTutorial(myprofile.account_config && myprofile.account_config.show_offer_tutorial);
  }, [myprofile.account_config]);

  useEffect(() => {
    if (isOfferModalOpen === true && !isCounter) {
      isLightboxOpen
        ? vysionTrack(
            {
              action: 'click',
              component: 'Make Offer',
              extraInfo: '',
              page: 'Lightbox',
            },
            'lightbox-makeOffer'
          )
        : // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          displayOfferModal(window.event);
    }
  }, [isOfferModalOpen, isCounter, isLightboxOpen]);

  useEffect(() => {
    if (isOfferModalOpen === true && isCounter === true) {
      counterModal('view');
    }
  }, [isOfferModalOpen, isCounter]);

  useEffect(() => {
    if (account.notFound && !account.hash_id) {
      dispatch(clearNotificationMessage());
    }
  }, [account.notFound, !account?.hash_id]);

  const createNewOffer = async formData => {
    dispatch(createNewOfferProps(formData));
  };

  const showSuccessMigrateModal = () => {
    basicModal({
      dateTestId: 'migrate-success',
      modalContentLabel: 'Success Profile Migrate',
      isModalOpen: true,
      modalBody: (
        <div style={{ textAlign: 'center' }}>
          <HeaderOut onBoardingSuccess />
          <h3>Profile successfully created!</h3>
          <div style={{ marginBottom: 20 }}>
            Continue making edits or start finding your next date!
            <br /> {isGenerous ? '50 credits has been deposited into your account.' : ''}
          </div>
          <ButtonSet align="center">
            <Button
              id="EditProfile"
              buttonType="normal"
              customStyle={{ borderColor: '#2490de', color: '#2490de' }}
              onClick={resetModal}
              type="submit"
            >
              Edit Profile
            </Button>
            <Button
              id="EditProfile"
              buttonType="primaryRed"
              onClick={() => {
                window.location.href = '/search';
                resetModal();
              }}
              type="submit"
            >
              Browse Members
            </Button>
          </ButtonSet>
        </div>
      ),
    });
  };

  let currencyInitial;
  let currencyLabelUnicode;

  if (account && account.currency && isAttractive(acctProfile)) {
    currencyInitial = account.currency.data.initial;
    currencyLabelUnicode = account.currency.data.label_unicode;
  } else {
    currencyInitial = myprofile && myprofile.currency && myprofile.currency.data.initial;
    currencyLabelUnicode = myprofile && myprofile.currency && myprofile.currency.data.label_unicode;
  }

  const updateSliderPosition = (currPosition, isLightboxOn = false) => {
    setSliderPosition(currPosition);
    setIsLightbox(isLightboxOn);
  };

  const handleSuggestion = () => {
    setJustSuggested(true);

    dispatch(sendSuggestion(account.hash_id, false, null, null))
      .then(() => {
        offerModalClose();
      })
      .catch(() => {
        setHasErrors(true);
      });
  };

  const lightboxOnClose = (activeIndex: number) => {
    setIsLightboxOpen(false);
    setCurrentImage(-1);

    if (gallerySwiper) {
      gallerySwiper.slideToLoop(activeIndex, 0);
    }
  };

  const openLightbox = index => {
    setCurrentImage(index);
    setIsLightboxOpen(true);
  };

  const openTrackLightbox = (index, event) => {
    vysionTrack(
      {
        action: 'view',
        component: 'Display',
        extraInfo: '',
        page: 'Lightbox',
      },
      'lightbox'
    );
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    openLightbox(index, event);
  };

  const offerModalOpen = openCounter => {
    setIsOfferModalOpen(true);
    setIsCounter(openCounter);
  };

  const offerModalClose = () => {
    setIsOfferModalOpen(false);
  };

  const closeModalTracking = e => {
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    isCounter ? counterModalClose(e) : sendClose(e);
    offerModalClose();
  };

  const handleCounterOffer = formData => {
    return dispatch(counterOffer(formData, false, navigate));
  };

  const canMakeOffer = () => {
    profileMakeOffer();
    try {
      const { cannot_make_offer_reasons } = myprofile;

      if (cannot_make_offer_reasons === null) {
        return true;
      }

      if (cannot_make_offer_reasons[0].indexOf('many unlocked offers') > -1) {
        trackPackagesPageVisited({ Source: 'Offers Limit' });
        navigate('/packages?newPayWall=true&unlimitedAccess=true');

        return false;
      }

      if (cannot_make_offer_reasons[0].indexOf('many locked deals') > -1) {
        trackPackagesPageVisited({ Source: 'Offers Limit' });
        setShowTooManyPendingOfferModal(true);
        return false;
      }

      return true;
    } catch (e) {
      console.error(e);
    }

    return false;
  };

  const toggleProfileBlock = () => {
    scrollToTop();
    // notify store.
    dispatch(toggleBlockInStore(account.hash_id));
    // notify api.
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    dispatch(toggleBlockProfile(account.username, account.hash_id, !account.is_blocked));
  };

  const backOrDashboard = () => {
    const urlEmailToken = location.search.indexOf('email_ref') > -1;
    const urlNotifToken = location.search.indexOf('notif_ref') > -1;
    const urlMigration = location.search.indexOf('migration_edit') > -1;
    const notAppUrl = prevPage && prevPage.length <= 0;

    if (urlEmailToken || urlNotifToken || urlMigration || notAppUrl) {
      navigate('/dashboard');
      return;
    }

    navigate(-1);
  };

  const renderBlockedWarning = () => {
    return (
      <BlockedContainer>
        <StyledText>You have Blocked this member</StyledText>
        <Button buttonType="primaryRed" onClick={() => toggleProfileBlock()}>
          Unblock
        </Button>
      </BlockedContainer>
    );
  };

  const toggleFav = hashId => {
    // notify extprofile store
    dispatch(storeProfileFavChange());
    // notify api.
    dispatch(favToggle(hashId));
  };

  const RenderProfileCover = (otherProfile = false) => {
    const { showNotificationBanner } = useNotificationBanner();
    const myProfileData = getMyProfileData(myprofile, 'data');
    const [photoListCover] = generatePhotoList(account, true);
    const myPhotos = { data: _sortBy(photos.data, ['rank', 'order']) };

    const onFavoritedProfile = () => {
      showMandatoryWall(
        () => {
          if (account.is_favorite) {
            toggleFav(account.hash_id);
            showNotificationBanner({
              type: 'error',
              message: <FavoritedProfileNotificationBanner action="unfavorited" />,
            });
            return;
          }

          // when user favorites
          // check if capable of making offer
          toggleFav(account.hash_id);

          mixpanelTrackEvent({
            eventName: EVENT_NAMES.PROFILE_FAVORITED,
            payload: {
              eventProperties: {
                Source: 'Profile',
                User: account.hash_id,
              },
              incrementalProperties: {
                '# favorites': 1,
              },
            },
          });

          showNotificationBanner({
            type: 'success',
            message: <FavoritedProfileNotificationBanner action="favorited" />,
          });
        },
        () => undefined,
        'Favorite',
        false,
        ['emailWall', 'profileWall']
      );
    };

    if (otherProfile) {
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      const offer = _find(['offer', 'data'], account);
      const otherProfileModel = ProfileMaker.create({
        data: acctProfile,
      } as ProfileObject);

      return (
        <OtherProfileCover
          username={account.username}
          age={acctProfile.age}
          location={displayUserLocation(myProfileData, acctProfile)}
          lastLoginTime={otherProfileModel.lastActivityStatus()}
          lastLoginLocation={acctProfile.last_access_location_full || ''}
          profileImg={memoisedAccountAvatar}
          onClickPhoto={openTrackLightbox}
          favorited={Boolean(account.is_favorite)}
          onClickFavorite={onFavoritedProfile}
          myPhotos={myPhotos}
          otherProfilePhotos={photoListCover}
          isOtherProfile={otherProfile}
          isVerified={acctProfile.id_verified}
          isSelfieVerified={acctProfile.selfie_verified}
          offer={offer}
          myProfile={myProfileData}
          evidently={evidently}
        >
          {myProfileData && myProfileData.account_type === acctProfile.account_type ? (
            <p style={{ color: '#ff0000' }}>You can&#39;t make offers to members with the same account type as you</p>
          ) : !account.is_blocked ? (
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            <ExperimentInjector testId="SJq179csTtWq7OXP3KL2iA" prodId="6Q9KuEX1QrqJDclOYgDEhA">
              <OfferPanelV2
                account={account}
                offerType={getOfferType(offer, myprofile)}
                createdAt={getMyOfferData(offer, 'created_at.date')}
                myProfile={myprofile}
                username={account.username}
                hashId={account.hash_id}
                offer={myOffer}
                createNewOffer={createNewOffer}
                counterOffer={handleCounterOffer}
                isCounter={isCounter}
                closeModal={offerModalClose}
                currencyInitial={currencyInitial}
                currencyLabel={currencyLabelUnicode}
                currentUserIsGenerous={
                  myprofile &&
                  myprofile.profile &&
                  Boolean(getMyProfileData(myprofile, 'data.account_type') === 'Generous')
                }
                setJustSuggested={setJustSuggested}
                ignoreStatus={ignored}
                showOfferTutorial={showOfferTutorial}
                isFirstTimeTutorial={myprofile.account_config && myprofile.account_config.show_offer_tutorial}
                canMakeOffer={canMakeOffer}
                unlockMessage={(hashId, triggerToBuy, callback = () => undefined) => {
                  dispatch(unlockOutsideMessage(hashId, triggerToBuy, callback, isGenerous, navigate));
                }}
              />
            </ExperimentInjector>
          ) : (
            renderBlockedWarning()
          )}
        </OtherProfileCover>
      );
    }

    return (
      <MyProfileCover
        username={myprofile.username}
        age={acctProfile.age}
        location={displayUserLocation(acctProfile, myprofile?.profile?.data)}
        profileImgUrl={myprofile.profile?.data?.avatar.data.urls}
        profileImgFallback={acctProfile.avatar.data.urls['resized']}
        onClickPhoto={openTrackLightbox}
        account={myprofile}
        myPhotos={myPhotos}
        isVerified={acctProfile.id_verified}
        isUpdatingProfileCover={myprofile.isUpdatingProfileCover}
        editable
      />
    );
  };

  if (account.notFound && !account.hash_id) {
    return (
      <BlankSlate
        title="We can't show you this profile"
        message="This profile was either deactivated, removed, or never existed."
        action={
          <Button onClick={backOrDashboard} buttonType="primaryRed">
            Find someone better
          </Button>
        }
      />
    );
  }

  if (!account.profile) {
    return (
      <div>
        <TrackLoadingToMixpanel page="Profile - loading profile" />
        <LoadingMsg msg="Loading Profile" />
      </div>
    );
  }

  return (
    <StyledContainer id="ProfileContainer" isLightboxOpen={isLightboxOpen}>
      <LeftContent isLightboxOpen={isLightboxOpen}>
        <CloseProfileContainer
          id="closeProfileContainer"
          data-test-id="close-profile-container"
          hasStatus={myOffer && (myOffer.status === 'pending' || myOffer.status === 'accepted')}
        >
          <CloseProfileHandler onClick={backOrDashboard}>
            <ArrowBackIcon />
          </CloseProfileHandler>
        </CloseProfileContainer>
        <LeftContentMainPanel isOtherProfile={isOtherProfile}>
          <MainPanel panelStyle="white" isOtherProfile={isOtherProfile}>
            <ProfileHeading>{RenderProfileCover(isOtherProfile)}</ProfileHeading>
          </MainPanel>

          {!isOtherProfile && isMobile && <MyVerifications />}

          <ProfileGalleryWrapper>
            <Panel
              data-test-id="user-gallery-container"
              withHeader={false}
              panelStyle="borderless"
              customStyle={{
                marginTop: 15,
                marginBottom: 15,
                padding: '0 15px 15px',
                [breakpoints.down(768.05)]: {
                  backgroundColor: isOtherProfile ? getBackgroundTheme().block2 : getBackgroundTheme().block3,
                  margin: 0,
                  boxShadow: 'none',
                  borderRadius: 0,
                  border: 'none',
                },
              }}
            >
              {myprofile?.gallery?.isFetching && <LoadingBackdrop active={true} showLoadingBg={true} />}
              <Photos
                photos={photoList}
                openLightbox={openTrackLightbox}
                isOtherProfile={isOtherProfile}
                photoData={photos}
                profile={myprofile}
              />
            </Panel>
          </ProfileGalleryWrapper>
        </LeftContentMainPanel>

        <LeftContentWrapper>
          <Optional show={isMobile}>
            <WrappedWithMobile>
              {isEditable && Boolean(getMyProfileData(myprofile, 'data.account_type') === 'Attractive') && (
                <OpeningOffer data-test-id="profile-opening-offer" key="profile-opening-offer" />
              )}
            </WrappedWithMobile>
          </Optional>
          <AboutMe
            data-test-id="user-about-myself-container"
            description={ternaryFunc(
              isEditable && myprofile,
              myprofile.profile && myprofile.profile.data.description,
              acctProfile.description
            )}
            editable={isEditable}
            isProcessing={myprofile.isUpdatingDescription}
            themeDarkMode={isDarkMode()}
          />
          <FirstDate
            data-test-id="user-first-date-container"
            seeking={ternaryFunc(
              isEditable && myprofile,
              myprofile.profile && myprofile.profile.data.seeking,
              acctProfile.seeking
            )}
            editable={isEditable}
            isProcessing={myprofile.isUpdatingSeekingDesc}
            themeDarkMode={isDarkMode()}
          />
        </LeftContentWrapper>
      </LeftContent>

      <RightContent>
        {!isOtherProfile && !isMobile && <MyVerifications />}

        <Optional show={!isMobile}>
          <WrappedWithDesktop>
            {isEditable && Boolean(getMyProfileData(myprofile, 'data.account_type') === 'Attractive') && (
              <OpeningOffer data-test-id="profile-opening-offer" key="attractive-opening-offer" />
            )}
          </WrappedWithDesktop>
        </Optional>

        <PersonalInfo
          data-test-id="profile-info-about"
          myProfile={getPersonalInfo(
            ternaryFunc(isEditable && myprofile, myprofile.profile && myprofile.profile.data, acctProfile)
          )}
          editable={isEditable}
          acctProfile={acctProfile}
          themeDarkMode={isDarkMode()}
        />

        <InterestedIn
          data-test-id="profile-info-interested"
          profile={getInterestedIn(
            ternaryFunc(isEditable && myprofile, myprofile.profile && myprofile.profile.data, acctProfile)
          )}
          editable={isEditable}
          themeDarkMode={isDarkMode()}
        />

        {isOtherProfile && (
          <div>
            <BlockOrReport
              hashId={account.hash_id}
              username={account.username}
              avatar={memoisedAccountAvatar}
              isBlocked={Boolean(account.is_blocked)}
              onToggleBlock={toggleProfileBlock}
            />
          </div>
        )}
      </RightContent>

      <PhotoLightbox
        avatar={memoisedAccountAvatar}
        images={photoList}
        allowZoom={allowZoom}
        lightboxIsOpen={isLightboxOpen}
        currentImage={currentImage}
        onClose={lightboxOnClose}
        userHasPrivatePhotos={privatePhotoList.length > 0}
        photoListLength={photoList.length}
        privatePhotoCount={privatePhotoList.length}
        isOnboarded={onboarded}
        onOfferClick={offerModalOpen}
        justSuggested={justSuggested}
        ignoreStatus={ignored}
        username={account.username}
        account={account}
        hashId={account.hash_id}
        isBlocked={account.is_blocked}
        myprofile={myprofile}
        offer={myOffer}
        isOfferBtnVisible={isOtherProfile && isMobile && !myOffer}
        updateSliderPosition={updateSliderPosition}
        currentUserIsGenerous={isGenerous}
      />

      {isOfferModalOpen && (
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        <ReactModal
          isOpen={isOfferModalOpen}
          className={`${css(ModalStyles)}`}
          overlayClassName={`${css(OverlayStyles)}`}
          contentLabel="Create Offer Modal"
          shouldCloseOnOverlayClick={true}
          onRequestClose={offerModalClose}
        >
          <CloseBtn onClick={e => closeModalTracking(e)}>
            <SvgIcon component={CloseOutlined} style={closeButton} />
          </CloseBtn>

          <OfferCreate
            buttonID="button-offer-create"
            avatarSrc={memoisedAccountThumbAvatar}
            username={account.username}
            hashId={account.hash_id}
            offer={myOffer}
            createNewOffer={createNewOffer}
            counterOffer={handleCounterOffer}
            isCounter={isCounter}
            closeModal={offerModalClose}
            currencyInitial={currencyInitial}
            currencyLabel={currencyLabelUnicode}
            currentUserIsGenerous={isGenerous}
            sex={acctProfile.sex}
            sendSuggestion={handleSuggestion}
            cannot_make_offer_reasons={myprofile.cannot_make_offer_reasons}
            ignoreStatus={ignored}
            justSuggested={justSuggested}
            otherProfile={acctProfile}
          />
        </ReactModal>
      )}
    </StyledContainer>
  );
};

export default Profile;
